import React from 'react';
import { useForm } from 'react-hook-form';
import { Container, Form, Row } from 'reactstrap';
import { Breadcrumbs } from '../../../AbstractElements';
import LeftForm from './LeftForm';
import RightForm from './RightForm';

const AddProductContainer = () => {
  const {
    control,
    reset,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const formSubmitHandler = (data) => {
    reset();
  };

  return (
    <>
      <Container fluid={true} className='add-product'>
        <Breadcrumbs pageTitle='Add Product' parent='Ecommerce' title='Add Product' />
        <Form onSubmit={handleSubmit(formSubmitHandler)}>
          <Row>
            <LeftForm errors={errors} control={control} register={register} />
            <RightForm errors={errors} control={control} register={register} />
          </Row>
        </Form>
      </Container>
    </>
  );
};

export default AddProductContainer;
